<template>
  <Layout>
    <template #header> HDC陡坡缓降 </template>
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-4 column justify-around">
        <q-card bordered class="full-height column">
          <q-card-section class="column" style="flex: 1">
            <div class="row space-x-4 items-center">
              <ToggleSwitch
                :disabled="notifyData.UIRx_HDCAvlbl === 0"
                :model-value="switching"
                @update:model-value="handleSwitchChange"
                color="#4caf50"
              ></ToggleSwitch>

              <div
                v-if="notifyData.UIRx_HDCAvlbl === 0"
                class="text-red text-lg font-bold"
              >
                当前HDC不可用，暂不可激活
              </div>
            </div>
            <q-card-section class="row" style="flex: 1">
              <HDCMonitor :notifyData="notifyData" />
            </q-card-section>
            <div class="row justify-end">
              <PlayPauseButton
                :initial-state="playStatus === 'play'"
                @toggle="handlePlayStatusChange"
              />
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-8 column q-col-gutter-y-md">
        <div style="flex: 1">
          <q-card bordered class="column full-height">
            <q-card-section class="q-pa-none" style="flex: 1">
              <div class="full-height column">
                <div style="flex: 1">
                  <DomainControlCharts
                    ref="chartRef1"
                    :max="150"
                    :min="0"
                    :series="options1"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom1"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 1)"
                    :showXAxisLabel="false"
                  />
                </div>
                <div class="overflow-hidden" style="flex: 1">
                  <DomainControlCharts
                    ref="chartRef2"
                    :max="40000"
                    :min="0"
                    :series="options2"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom2"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 2)"
                    :showXAxisLabel="true"
                  />
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, watch } from "vue";
import {
  PlayStatus,
  LENGTH,
  decreasingSequence,
  getDefaultSeriesData,
  optionseries1,
  optionseries2,
  getDataZoom1,
  getDataZoom2,
} from "./helper/hdc";
import Layout from "./components/Layout.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import {
  generateMockHDCNotifyData,
  NOTIFY,
} from "@/services/domainControl/hdc";
import DomainControlCharts from "@/components/DomainControlCharts";
// import Statistic from "@/views/DomainControl/components/IVSE/Statistic";
import ToggleSwitch from "@/components/ToggleSwitch";
import PlayPauseButton from "@/components/PlayPauseButton.vue";
import HDCMonitor from "@/views/DomainControl/components/HDC/HDCMonitor.vue";
import { useDomainControlStore } from "@/stores/domainControl";
import { Loading } from "quasar"; // useQuasar 会导致 vue devtools 无法显示组件属性
import { isDev } from "@/utils/env";

const domainControlStore = useDomainControlStore();

const dataZoom1 = getDataZoom1();
const dataZoom2 = getDataZoom2();

const switching = ref(false);

const seriesData = ref(getDefaultSeriesData());
const options1 = ref(optionseries1());
const options2 = ref(optionseries2());

const chartRef1 = ref<InstanceType<typeof DomainControlCharts>>();
const chartRef2 = ref<InstanceType<typeof DomainControlCharts>>();

const playStatus = ref<PlayStatus>("play");
const notifyData = reactive(
  isDev
    ? ({
        UIRx_HDCAvlbl: 1,
        UIRx_HDCCtrlA: 1,
        UIRx_VehSpd: 0,
        UIRx_HDCActualSpeed: 15.123,
        UIRx_HDCDispVxTar: 0,
      } as any as DomianControl.HDCNotifyData)
    : ({} as any as DomianControl.HDCNotifyData)
);

watch(
  () => seriesData.value,
  (newValue) => {
    const {
      UIRx_VehSpd,
      UIRx_HDCDispVxTar,
      UIRx_VAFBrkFxTrgt,
      UIRx_DrvrReqTrgtFxBrk_Bch1,
    } = newValue;

    (options1?.value as any)[0].data = UIRx_VehSpd;
    (options1?.value as any)[1].data = UIRx_HDCDispVxTar;

    (options2?.value as any)[0].data = UIRx_VAFBrkFxTrgt;
    (options2?.value as any)[1].data = UIRx_DrvrReqTrgtFxBrk_Bch1;
  },
  { deep: true }
);

const parseData = async (data: DomianControl.HDCNotifyData) => {
  const newData = {} as any;
  Object.keys(data).forEach((key) => {
    let value = data[key];
    notifyData[key] = value;
    newData[key] = value;
    if (key === "UIRx_HDCCtrlA") {
      switching.value = value > 0 && value < 3 ? true : false;
    }
  });

  return newData;
};

const handleNotify = async (data: DomianControl.HDCNotifyData) => {
  // console.log("[BOWEN_LOG] 🚀 ~~ handleNotify ~~ data:", data);
  const newData = await parseData(data);
  // 开关开启 && palying
  if (playStatus.value === "play") parseSeriesData(newData);
};

const handleDataZoom = (value: any, key = 1) => {
  const { end, start, dataZoomId } = value;
  if (dataZoomId === "dataZoomY") {
    const dataZoom = [{}, { end, start: 0 }];
    if (key === 2) {
      chartRef2.value?.echarts?.setOption({
        dataZoom: dataZoom,
      });
    }
  }
  if (dataZoomId === "dataZoomX") {
    const dataZoom = [{ end, start }, {}];
    chartRef1.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
    chartRef2.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
  }
};

const parseSeriesData = (data: DomianControl.HDCNotifyData) => {
  const res = [
    "UIRx_VehSpd",
    "UIRx_HDCDispVxTar",
    "UIRx_VAFBrkFxTrgt",
    "UIRx_DrvrReqTrgtFxBrk_Bch1",
  ].reduce((per, key) => {
    let value = data[key];
    if (["UIRx_VAFBrkFxTrgt", "UIRx_DrvrReqTrgtFxBrk_Bch1"].includes(key)) {
      value = Math.abs(value);
    }
    const curList = (seriesData.value as any)[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    per[key] = curList.concat();
    return per;
  }, {} as DomianControl.HDCSeriesData);
  seriesData.value = res;
};

const handlePlayStatusChange = async () => {
  // setChartsDataZoom(value);
  const value = playStatus.value === "play" ? "pause" : "play";
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    if (!isNotifyed.value) {
      Loading.show();
      await startNotifications().finally(() => Loading.hide());
    }
  }
  playStatus.value = value;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  // const { UITx_AdaDrvrCtrlSt } = value;
  // switching.value = UITx_AdaDrvrCtrlSt === 0 ? false : true;
};

const handleSwitchChange = (value: any) => {
  Loading.show();
  // switching.value = value;
  toggleActive();
  setTimeout(() => {
    Loading.hide();
  }, 2000);
};

const toggleActive = () => {
  // UITx_HDCCfg会发送0 - 1 - 0信号 间隔 1s
  domainControlStore.writeOutputValue({
    UITx_HDCCfg: 0,
  });
  setTimeout(() => {
    domainControlStore.writeOutputValue({
      UITx_HDCCfg: 1,
    });
  }, 1000);
  setTimeout(() => {
    domainControlStore.writeOutputValue({
      UITx_HDCCfg: 0,
    });
  }, 2000);
};

const { startNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

onMounted(() => {
  // setInterval(() => {
  //   handleNotify(generateMockHDCNotifyData() as any);
  // }, 50);
});
</script>

<style scoped lang="scss">
.arrow-group {
  &.top {
    top: 56px;
  }
  &.left {
    left: -40px;
  }
  &.right {
    right: -40px;
  }
  &.bottom {
    bottom: 193px;
  }
  .arrow-left,
  .arrow-right {
    position: absolute;
  }
  .arrow-left {
    left: -35px;
  }
  .arrow-right {
    right: -35px;
  }
  // .arrow-bottom {
  //   margin-top: 10px;
  //   transform: rotate(180deg);
  // }
}
.pie {
  &.top {
    top: 79px;
  }
  &.left {
    left: -118px;
  }
  &.right {
    right: -118px;
  }
  &.bottom {
    bottom: 110px;
  }
  // .arrow-bottom {
  //   margin-top: 10px;
  //   transform: rotate(180deg);
  // }
}
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}
.q-img {
  overflow: unset;
}

:deep(.q-btn-group .q-btn) {
  padding: 0px 38px !important;
}

:deep(.q-btn-group .q-btn:not(:first-of-type)) {
  // border-left: 1px solid #ccc;
}
</style>
